export default "__VITE_ASSET__KEWk9d7Y__"